import { Module, Action, getModule, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import { sessionStore } from '@/store/session/SessionStoreModule'
import { ApiAgent } from '@/plugins/ApiRequest'
import * as ApiPath from '@/tcw/constant/ApiPath'
import { MShokui, MShozoku } from '@/tcw/api/types'

/**
 * メッセージSTORE
 */
@Module({
  name: 'MasterStoreModule',
  store,
  namespaced: true,
  dynamic: true
})
export default class MasterStoreModule extends VuexModule {
  private shozokuList: MShozoku[] | null = null
  private shokuiList: MShokui[] | null = null

  /****************
   * Mutation
   ****************/
  @Mutation
  private setShozokuList(shozokuList: MShozoku[]) {
    this.shozokuList = shozokuList
  }
  @Mutation
  private setShokuiList(shokuiList: MShokui[]) {
    this.shokuiList = shokuiList
  }

  /****************
   * Action
   ****************/
  /**
   * 所属リスト取得
   */
  @Action({ rawError: true })
  public async fetchMShozoku(): Promise<MShozoku[]> {
    if (this.shozokuList) {
      return Promise.resolve(this.shozokuList)
    }

    // API実行
    try {
      const apiAgent = ApiAgent.create(
        process.env.VUE_APP_API_URL_BASE as string,
        sessionStore.sessionToken
      )
      const path = ApiPath.Paths.MShozoku.list
      const response: MShozoku[] = await apiAgent.call<MShozoku[]>(path, 'GET')

      // STOREにセットする
      this.setShozokuList(response)

      // 呼び出し側に送る
      return Promise.resolve(response)
    } catch (e) {
      console.error('failure fetch master data', e)
      return Promise.reject(e)
    }
  }
  /**
   * 職位リスト取得
   */
  @Action({ rawError: true })
  public async fetchMShokui(): Promise<MShokui[]> {
    if (this.shokuiList) {
      return Promise.resolve(this.shokuiList)
    }

    // API実行
    try {
      const apiAgent = ApiAgent.create(
        process.env.VUE_APP_API_URL_BASE as string,
        sessionStore.sessionToken
      )
      const path = ApiPath.Paths.MShokui.list
      const response: MShokui[] = await apiAgent.call<MShokui[]>(path, 'GET')

      // STOREにセットする
      this.setShokuiList(response)

      // 呼び出し側に送る
      return Promise.resolve(response)
    } catch (e) {
      console.error('failure fetch master data', e)
      return Promise.reject(e)
    }
  }
}

export const masterStore = getModule(MasterStoreModule)
